export default {
  nullValue: 'No data',
};
